import React, { Component } from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'

const styles = {
  wrapperOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0,
    margin: 0,
    height: '100vh',
    paddingLeft: 'env(safe-area-inset-left)',
    paddingRight: 'env(safe-area-inset-right)',
    paddingTop: 'env(safe-area-inset-top)',
    paddingBottom: 'env(safe-area-inset-bottom)',
  },
  wrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0,
    margin: 0,
    height: '100%',
    // height: 'calc(83vh + 2vh)',
    backgroundColor: '#F2F2F2',
    paddingLeft: 'env(safe-area-inset-left)',
    paddingRight: 'env(safe-area-inset-right)',
    paddingTop: 'env(safe-area-inset-top)',
    paddingBottom: 'env(safe-area-inset-bottom)',
  },
}

@injectSheet(styles)
class MobileWrapper extends Component {
  render() {
    const { children, classes, overlay } = this.props
    return <div className={overlay ? classes.wrapperOverlay : classes.wrapper}>{children}</div>
  }
}

MobileWrapper.propTypes = {
  overlay: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object,
}

export default MobileWrapper
